"use strict"; // tslint:disable:max-classes-per-file

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");
/**
 * The flag represents situation when some entity has been deleted, i.e. in an external system.
 */


var WindowStateDeleted =
/*#__PURE__*/
function (_EntityStateFlag_1$En) {
  _inherits(WindowStateDeleted, _EntityStateFlag_1$En);

  function WindowStateDeleted() {
    _classCallCheck(this, WindowStateDeleted);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowStateDeleted).apply(this, arguments));
  }

  _createClass(WindowStateDeleted, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return WindowStateDeleted;
}(EntityStateFlag_1.EntityStateFlag);

exports.WindowStateDeleted = WindowStateDeleted;
WindowStateDeleted.TAG = EntityStateFlag_1.EntityStateFlag.register(WindowStateDeleted);